import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { extractMessage } from './account-redirect';

export interface AuthErrorRedirectRule {
	statusCode: number;
	message: string;
	redirectTo: string;
}

export const AUTH_ERROR_REDIRECT_RULES = new InjectionToken<AuthErrorRedirectRule[]>('AUTH_ERROR_REDIRECT_RULES', {
	providedIn: 'root',
	factory: (): AuthErrorRedirectRule[] => []
});

@Injectable()
export class AuthErrorRedirectInterceptor implements HttpInterceptor {
	private readonly router = inject(Router);
	private readonly rules = inject(AUTH_ERROR_REDIRECT_RULES);

	public intercept(req: HttpRequest<unknown>, delegate: HttpHandler): Observable<HttpEvent<unknown>> {
		return delegate.handle(req).pipe(
			catchError((error: unknown) => {
				if (error instanceof HttpErrorResponse) {
					this.redirectForConfiguredRule(error);
				}

				return throwError(() => error);
			})
		);
	}

	private redirectForConfiguredRule(error: HttpErrorResponse): void {
		const normalizedMessage = extractMessage(error).toLowerCase();

		// Only redirect when a 403 carries a recognised message; guards handle the startup-endpoint fallback.
		for (const rule of this.rules) {
			if (error.status !== rule.statusCode) {
				continue;
			}

			if (normalizedMessage.includes(rule.message.toLowerCase())) {
				this.navigateIfNeeded(rule.redirectTo);
				return;
			}
		}
	}

	private navigateIfNeeded(path: string): void {
		if (this.router.url !== path) {
			void this.router.navigateByUrl(path);
		}
	}
}
